import gql from 'graphql-tag';

const FRAGMENT = gql`
 fragment User on users {
     user_id
     user_cognito_username
     user_email
     user_phone
     user_first_name 
     user_last_name 
     user_type 
     user_cognito_sub
     gender_pronounce 
     state  
     user_pic
     timezone
     calendar_enabled
     user_preferred_name
     gender
     last_login_at
     user_created_at
     auto_reply_message
     auto_reply_enabled
 }
`;

export const GET_USER = gql `
    query getUserinfo($sub: uuid!) {
        user: users(where: {user_cognito_sub: {_eq: $sub}}) {
            ...User
        }
    }
    ${FRAGMENT}
`;

export const UPDATE_USER = gql`
    mutation updateUser($sub: uuid!, $data: users_set_input!) {
        user: update_users(where: {user_cognito_sub: {_eq: $sub}}, _set: $data) {
            returning {
                ...User
            }
        }
    }
    ${FRAGMENT}
`;
